(function () {
  if (customElements.get("laboo-native-bundle")) return;

  var US_SIZE_RULES = [
    { pattern: /^13\s*x\s*18cm/i, label: "5 x 7 in", rank: 10 },
    { pattern: /^A4\s*-\s*21\s*x\s*29\.7cm/i, label: "8 x 12 in", rank: 20 },
    { pattern: /^27\s*x\s*35cm/i, label: "11 x 14 in", rank: 30 },
    { pattern: /^30\s*x\s*40cm/i, label: "12 x 16 in", rank: 40 },
    { pattern: /^40\s*x\s*50cm/i, label: "16 x 20 in", rank: 50 },
    { pattern: /^40\s*x\s*60cm/i, label: "16 x 24 in", rank: 60 },
    { pattern: /^50\s*x\s*70cm/i, label: "20 x 28 in", rank: 70 },
    { pattern: /^60\s*x\s*80cm/i, label: "24 x 32 in", rank: 80 },
    { pattern: /^60\s*x\s*90cm/i, label: "24 x 36 in", rank: 90 },
    { pattern: /^70\s*x\s*100cm/i, label: "28 x 40 in", rank: 100 },
    { pattern: /^75\s*x\s*100cm/i, label: "30 x 40 in", rank: 110 },
    { pattern: /^25\s*x\s*25cm/i, label: "10 x 10 in", rank: 210 },
    { pattern: /^30\s*x\s*30cm/i, label: "12 x 12 in", rank: 220 },
    { pattern: /^35\s*x\s*35cm/i, label: "14 x 14 in", rank: 230 },
    { pattern: /^40\s*x\s*40cm/i, label: "16 x 16 in", rank: 240 },
    { pattern: /^45\s*x\s*45cm/i, label: "18 x 18 in", rank: 250 },
    { pattern: /^50\s*x\s*50cm/i, label: "20 x 20 in", rank: 260 },
    { pattern: /^70\s*x\s*70cm/i, label: "28 x 28 in", rank: 270 }
  ];

  function normalizeTitle(value) {
    return String(value || "").replace(/^Size:\s*/i, "").trim();
  }

  function usSizeRule(value) {
    var title = normalizeTitle(value);
    if (/^A(?:0|1|2|3)\b/i.test(title)) return null;
    return US_SIZE_RULES.find(function (rule) { return rule.pattern.test(title); }) || null;
  }

  function imageUrl(value) {
    if (!value) return "";
    if (typeof value === "string") return value;
    return value.src || "";
  }

  class LabooNativeBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.handles = String(this.dataset.productHandles || "").split("|").filter(Boolean);
      this.minimum = Number(this.dataset.minimum || 1);
      this.preselectAll = this.dataset.preselectAll === "true";
      this.isUS = String(this.dataset.country || "").toUpperCase() === "US";
      this.products = new Array(this.handles.length);
      this.list = this.querySelector("[data-bundle-products]");
      this.status = this.querySelector("[data-bundle-status]");
      this.count = this.querySelector("[data-bundle-count]");
      this.submit = this.querySelector("[data-bundle-submit]");
      this.submitLabel = this.querySelector("[data-bundle-submit-label]");
      this.submitPrice = this.querySelector("[data-bundle-submit-price]");
      this.headingPrice = document.querySelector("[data-laboo-native-bundle-heading-price]");
      this.discountTiers = this.parseDiscountTiers(this.dataset.discountTiers);

      if (this.handles.length > 10) this.dataset.large = "true";
      this.renderSkeletons();
      this.submit.addEventListener("click", this.addSelected.bind(this));
      this.loadProducts();
    }

    parseDiscountTiers(value) {
      return String(value || "").split(",").map(function (tier) {
        var parts = tier.split(":");
        return { quantity: Number(parts[0]), discount: Number(parts[1]) };
      }).filter(function (tier) {
        return Number.isFinite(tier.quantity) && Number.isFinite(tier.discount);
      }).sort(function (a, b) { return a.quantity - b.quantity; });
    }

    renderSkeletons() {
      this.list.innerHTML = this.handles.map(function (_, index) {
        return '<div class="laboo-native-bundle__skeleton" data-bundle-slot="' + index + '" aria-hidden="true"></div>';
      }).join("");
    }

    async loadProducts() {
      var nextIndex = 0;
      var workerCount = Math.min(4, this.handles.length);
      var workers = Array.from({ length: workerCount }, async () => {
        while (nextIndex < this.handles.length) {
          var index = nextIndex++;
          await this.loadProduct(index);
        }
      });

      await Promise.all(workers);
      this.list.setAttribute("aria-busy", "false");
      this.updateSummary();
    }

    async loadProduct(index) {
      var handle = this.handles[index];
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

      try {
        var response = await fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        if (!response.ok) throw new Error("Product request failed");

        var product = await response.json();
        var variants = this.availableVariants(product.variants || []);
        if (!variants.length) throw new Error("No available sizes");

        this.products[index] = {
          handle: handle,
          product: product,
          variants: variants,
          variant: variants[0].variant,
          selected: this.preselectAll
        };
        this.renderProduct(index);
      } catch (error) {
        this.products[index] = { handle: handle, error: true, selected: false };
        var slot = this.list.querySelector('[data-bundle-slot="' + index + '"]');
        if (slot) {
          slot.className = "laboo-native-bundle__product";
          slot.textContent = this.dataset.labelError;
        }
      }
    }

    availableVariants(variants) {
      var output = variants.filter(function (variant) { return variant.available; }).map((variant, index) => {
        if (!this.isUS) {
          return { variant: variant, label: normalizeTitle(variant.title), rank: index };
        }

        var rule = usSizeRule(variant.title);
        return rule ? { variant: variant, label: rule.label, rank: rule.rank } : null;
      }).filter(Boolean);

      if (this.isUS) output.sort(function (a, b) { return a.rank - b.rank; });
      return output;
    }

    renderProduct(index) {
      var state = this.products[index];
      var product = state.product;
      var slot = this.list.querySelector('[data-bundle-slot="' + index + '"]');
      var link = product.url || ("/products/" + state.handle);
      var featuredImage = imageUrl(product.featured_image || (product.images && product.images[0]));
      var options = state.variants.map(function (entry) {
        return '<option value="' + entry.variant.id + '">' + this.escape(entry.label) + "</option>";
      }, this).join("");

      slot.className = "laboo-native-bundle__product" + (state.selected ? " is-selected" : "");
      slot.removeAttribute("aria-hidden");
      slot.innerHTML =
        '<a class="laboo-native-bundle__image-link" href="' + this.escape(link) + '">' +
          '<img class="laboo-native-bundle__image" src="' + this.escape(featuredImage) + '" alt="' + this.escape(product.title) + '" loading="lazy" width="360" height="360">' +
        "</a>" +
        '<a class="laboo-native-bundle__product-title" href="' + this.escape(link) + '">' + this.escape(product.title) + "</a>" +
        '<div class="laboo-native-bundle__price" data-bundle-product-price></div>' +
        '<select class="laboo-native-bundle__select" aria-label="' + this.escape(product.title) + '" data-bundle-variant>' + options + "</select>" +
        '<button class="laboo-native-bundle__toggle" type="button" data-bundle-toggle aria-pressed="' + state.selected + '">' +
          this.escape(state.selected ? this.dataset.labelAdded : this.dataset.labelAdd) +
        "</button>";

      var select = slot.querySelector("[data-bundle-variant]");
      var toggle = slot.querySelector("[data-bundle-toggle]");
      select.addEventListener("change", () => {
        state.variant = state.variants.find(function (entry) {
          return String(entry.variant.id) === select.value;
        }).variant;
        this.updateProductPrice(slot, state.variant);
        this.updateSummary();
      });
      toggle.addEventListener("click", () => {
        state.selected = !state.selected;
        slot.classList.toggle("is-selected", state.selected);
        toggle.setAttribute("aria-pressed", String(state.selected));
        toggle.textContent = state.selected ? this.dataset.labelAdded : this.dataset.labelAdd;
        this.updateSummary();
      });

      this.updateProductPrice(slot, state.variant);
      this.updateSummary();
    }

    updateProductPrice(slot, variant) {
      var price = slot.querySelector("[data-bundle-product-price]");
      var compare = Number(variant.compare_at_price || 0);
      price.innerHTML = "<span>" + this.escape(this.formatMoney(variant.price)) + "</span>" +
        (compare > Number(variant.price) ? "<del>" + this.escape(this.formatMoney(compare)) + "</del>" : "");
    }

    selectedProducts() {
      return this.products.filter(function (state) {
        return state && !state.error && state.selected && state.variant;
      });
    }

    discountFor(quantity) {
      return this.discountTiers.reduce(function (discount, tier) {
        return quantity >= tier.quantity ? tier.discount : discount;
      }, 0);
    }

    totals() {
      var selected = this.selectedProducts();
      var subtotal = selected.reduce(function (total, state) {
        return total + Number(state.variant.price || 0);
      }, 0);
      var compare = selected.reduce(function (total, state) {
        return total + Math.max(Number(state.variant.compare_at_price || 0), Number(state.variant.price || 0));
      }, 0);
      var discount = this.discountFor(selected.length);
      return {
        quantity: selected.length,
        subtotal: subtotal,
        compare: compare,
        total: Math.round(subtotal * (100 - discount) / 100)
      };
    }

    updateSummary() {
      var totals = this.totals();
      var allLoaded = this.products.filter(Boolean).length === this.handles.length;
      this.count.textContent = totals.quantity + " / " + this.handles.length;
      this.submit.disabled = !allLoaded || totals.quantity < this.minimum;
      this.submitLabel.textContent = totals.quantity ? this.dataset.labelSubmit : this.dataset.labelChoose;
      this.submitPrice.textContent = totals.quantity ? this.formatMoney(totals.total) : "";

      if (!allLoaded) {
        this.status.textContent = this.dataset.labelLoading;
      } else if (totals.quantity < this.minimum) {
        this.status.textContent = this.dataset.labelMinimum;
      } else {
        this.status.textContent = "";
      }

      if (this.headingPrice) {
        if (!totals.quantity) {
          this.headingPrice.textContent = "";
        } else {
          this.headingPrice.innerHTML = "<span>" + this.escape(this.formatMoney(totals.total)) + "</span>" +
            (totals.compare > totals.total ? "<del>" + this.escape(this.formatMoney(totals.compare)) + "</del>" : "");
        }
      }
    }

    async addSelected() {
      var selected = this.selectedProducts();
      if (selected.length < this.minimum || this.submit.disabled) return;

      this.submit.disabled = true;
      this.submit.classList.add("working");
      this.submit.setAttribute("aria-busy", "true");
      this.status.classList.remove("is-error");

      var items = selected.map((state) => ({
        id: Number(state.variant.id),
        quantity: 1,
        properties: { "_laboo_bundle": this.dataset.parentHandle }
      }));
      var cartAddUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url)
        ? KROWN.settings.routes.cart_add_url + ".js"
        : (((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart/add.js");

      try {
        var requestOptions = {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ items: items })
        };
        var result;

        if (typeof window.labooCartRequest === "function") {
          result = await window.labooCartRequest(cartAddUrl, requestOptions);
        } else {
          var response = await fetch(cartAddUrl, requestOptions);
          result = await response.json().catch(function () { return {}; });
          if (!result.status) result.status = response.status;
        }

        if (result && Number(result.status) >= 400) {
          throw new Error(result.description || result.message || this.dataset.labelError);
        }

        if (window.KROWN && KROWN.settings && KROWN.settings.cart_action === "page") {
          window.location.href = KROWN.settings.routes.cart_url;
          return;
        }

        var sectionText = typeof window.labooCartSectionText === "function"
          ? await window.labooCartSectionText(result)
          : await fetch("?section_id=helper-cart", { credentials: "same-origin" }).then(function (sectionResponse) {
              return sectionResponse.text();
            });

        this.renderCartDrawer(sectionText);
        var drawer = document.getElementById("site-cart-sidebar");
        if (drawer && typeof drawer.show === "function") drawer.show();
        var recommendations = document.getElementById("cart-recommendations-sidebar");
        if (recommendations && typeof recommendations.generateRecommendations === "function") {
          window.requestAnimationFrame(function () {
            recommendations.generateRecommendations();
          });
        }
      } catch (error) {
        this.status.textContent = error.message || this.dataset.labelError;
        this.status.classList.add("is-error");
      } finally {
        this.submit.classList.remove("working");
        this.submit.removeAttribute("aria-busy");
        this.updateSummary();
      }
    }

    renderCartDrawer(html) {
      if (!html) return;

      var section = new DOMParser().parseFromString(html, "text/html");
      var incomingForm = section.getElementById("AjaxCartForm");
      var incomingSubtotal = section.getElementById("AjaxCartSubtotal");
      var currentForm = document.getElementById("AjaxCartForm");
      var currentSubtotal = document.getElementById("AjaxCartSubtotal");
      if (!incomingForm || !incomingSubtotal || !currentForm || !currentSubtotal) return;

      currentForm.innerHTML = incomingForm.innerHTML;
      if (typeof currentForm.ajaxifyCartItems === "function") currentForm.ajaxifyCartItems();
      currentSubtotal.innerHTML = incomingSubtotal.innerHTML;

      document.querySelectorAll("[data-header-cart-count]").forEach(function (element) {
        var count = currentForm.querySelector("[data-cart-count]");
        if (count) element.textContent = count.textContent;
      });
      document.querySelectorAll("[data-header-cart-total]").forEach(function (element) {
        var total = currentForm.querySelector("[data-cart-total]");
        if (total) element.textContent = total.textContent;
      });
    }

    formatMoney(cents) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency: currency
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return (Number(cents || 0) / 100).toFixed(2) + " " + currency;
      }
    }

    escape(value) {
      var element = document.createElement("span");
      element.textContent = String(value == null ? "" : value);
      return element.innerHTML;
    }
  }

  customElements.define("laboo-native-bundle", LabooNativeBundle);
})();
